var _style, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotCheckedTertiary = function SvgNotCheckedTertiary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notCheckedTertiary_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 26 24",
    style: {
      enableBackground: "new 0 0 26 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".notCheckedTertiary_svg__st0{clip-path:url(#notCheckedTertiary_svg__SVGID_00000116231115473055837410000010415199596806884750_)}.notCheckedTertiary_svg__st1{clip-path:url(#notCheckedTertiary_svg__SVGID_00000050662940638883590890000001052942877160214162_)}.notCheckedTertiary_svg__st2{clip-path:url(#notCheckedTertiary_svg__SVGID_00000096744792543035781860000014287825170136286618_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "notCheckedTertiary_svg__SVGID_1_",
    d: "M0 0h26v24H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "notCheckedTertiary_svg__SVGID_00000092452082208192352450000000529309157056379035_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#notCheckedTertiary_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#notCheckedTertiary_svg__SVGID_00000092452082208192352450000000529309157056379035_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "notCheckedTertiary_svg__SVGID_00000124881567190962573150000008938015028718964655_",
    transform: "rotate(-60.988 11.456 11.507)",
    d: "M-.9-.5h24.8v24H-.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "notCheckedTertiary_svg__SVGID_00000023970704907614588620000012171385836920904615_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#notCheckedTertiary_svg__SVGID_00000124881567190962573150000008938015028718964655_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#notCheckedTertiary_svg__SVGID_00000023970704907614588620000012171385836920904615_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "notCheckedTertiary_svg__SVGID_00000059280061033792387800000017452119224220014014_",
    transform: "rotate(-60.988 11.456 11.507)",
    d: "M-.9-.5h24.8v24H-.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "notCheckedTertiary_svg__SVGID_00000075146986291431065930000006042958136826407335_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#notCheckedTertiary_svg__SVGID_00000059280061033792387800000017452119224220014014_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#notCheckedTertiary_svg__SVGID_00000075146986291431065930000006042958136826407335_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6.4C.2 8.8.4 11.3.8 13.8c.4 2.2 1.1 4.3 2.4 6.1.6.9 1.4 1.8 2.3 2.4s2 .9 3 1c1.1.1 2.2 0 3.2-.4 1.1-.5 2.1-1.2 3-2 2.1-1.7 4.6-3 6.8-4.7 1.9-1.5 3.6-3.6 3.9-6.1.3-2.4-.9-4.5-2.7-6-2.1-1.7-4.7-2.6-7.4-2.9-1.3-.2-2.7-.2-4-.2s-2.7.1-4 .2c-1.3.1-2.4.4-3.4 1.1C3 3 2.2 3.8 1.6 4.8c-.2.5-.5 1.1-.6 1.6",
    style: {
      fill: "#ecf2fe"
    }
  })))));
};
export default SvgNotCheckedTertiary;